import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: "J'ai acheté cet ebook un dimanche soir en pleurant. Le lundi matin, j'avais déjà fait le tri de ma garde-robe. Ça a l'air simple, mais ce geste m'a redonné un pouvoir que je n'avais pas senti depuis des années.",
  author: 'Isabelle, 43 ans, Québec. Maman de 2 enfants.'
}, {
  quote: "Je m'attendais à un guide 'développement personnel' banal. C'est bien plus que ça. C'est comme si quelqu'un avait enfin mis des mots sur tout ce que je ressentais sans pouvoir l'expliquer.",
  author: 'Marie-Claire, 38 ans, Lyon, France.'
}, {
  quote: "La section sur le Sanctuaire Intérieur a changé ma relation avec la solitude. Je n'en avais plus peur. Je l'attendais.",
  author: 'Sophie, 51 ans, Montréal, Québec.'
}];
export function TestimonialsSection() {
  return <section className="bg-white py-10 px-6 md:py-16" data-id="element-253">
      <div className="max-w-5xl mx-auto" data-id="element-254">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-255">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream p-6 rounded-lg border-l-4 border-burgundy" data-id="element-256">
              <div className="text-6xl text-gold mb-4 leading-none" data-id="element-257">"</div>
              <p className="italic text-charcoal mb-4 leading-relaxed" data-id="element-258">
                {testimonial.quote}
              </p>
              <p className="text-sm font-semibold text-burgundy" data-id="element-259">
                — {testimonial.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}